import React, { useContext, useEffect, useState } from "react";
import { StatusContext } from "../../contexts/Status.context";
import MenuList from "../../constants/menu.constants";
import {
  makeProblems,
  makeProblems2,
  shuffleArray,
  shuffleNumArray,
} from "../../utils";

import AWS from "aws-sdk";
import { apiService } from "../../services/api.service";
import { toast } from "react-toastify";
import LoadingScreen from "../../components/UI/LoadingScreen";
import i18next from "i18next";
import useTranslation from "../../hooks/useTranslation";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

AWS.config.update({
  region: "us-east-1",
  accessKeyId: "AKIA4AOPPY4EMH4YHPGQ",
  secretAccessKey: "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",
});

const MainMenu: React.FC = () => {
  const {
    pageStatus,
    setPageStatus,
    setEngine,
    setMechanics,
    setProblems,
    setMetvProblems,
    setMetvProblems2,
    setModule,
  } = useContext(StatusContext);

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [isNextStep, setIsNextStep] = useState<boolean>(false);

  const handleProblems = async (index: number) => {
    let folderName = "";
    switch (index) {
      case 2:
        folderName = "preposttest/";
        break;
      case 2:
        folderName = "preposttest/";
        break;
      case 4:
        folderName = "slow/";
        break;
      case 5:
        folderName = "4emotions/";
        break;
      case 6:
        folderName = "normal/";
        break;
      case 7:
        folderName = "fast/";
        break;
      case 8:
        folderName = "listening/";
        break;
      case 9:
        folderName = "muted/";
        break;
      case 10:
        folderName = "speaking/";
        break;
      case 11:
        folderName = "new/";
        break;
      case 12:
        folderName = "children/";
        break;
      case 13:
        folderName = "4khd/";
        break;
      case 14:
        folderName = "impact/";
        break;
      case 15:
        folderName = "preposttest/";
        break;
      default:
        break;
    }
    setModule(folderName.replace("/", ""));
    setIsLoading(true);
    try {
      const res = await apiService.getVideosFromAWS(folderName);
      const { data } = res;
      const array = shuffleArray(
        data
          .slice(1, data.length)
          .filter((item: string) => item.indexOf("-s.mp4") == -1)
      ).slice(0, 20);
      if (index === 13 || index === 14) {
        setMetvProblems2(makeProblems2(array));
      } else {
        setMetvProblems(makeProblems(array));
        setProblems(shuffleNumArray(20));
      }
    } catch (error) {
      toast.error("Failed to get problems.");
    }
    setIsLoading(false);
  };

  const handlePageStatus = async (page: string, index: number) => {
    try {
      if (index == 2 || (index >= 4 && index <= 15))
        await handleProblems(index);
      if (index !== 16) {
        setPageStatus(page);
      }
      if (index === 1) {
        setEngine("guide");
      } else if (index === 3) {
        setEngine("menu");
      } else if (index === 13 || index == 14) {
        setEngine("practice");
        setMechanics(2);
      } else if (index === 16) {
        setIsNextStep(true);
      } else if (index === 2 || index === 15) {
        setEngine("test");
        setMechanics(1);
      } else {
        setEngine("practice");
        setMechanics(1);
      }
    } catch (error) { }
  };

  return (
    <div className="">
      <div className="w-full px-[5%] md:pl-[35%] text-left text-white">
        <div className="text-2xl font-bold my-4">{t("Main Menu")}:</div>
        <div className="ml-8">
          <ol className="list-decimal text-lg">
            {MenuList[0].children.map((menu, index) => (
              <li
                key={`menu-${index + 1}`}
                className="my-1 cursor-pointer"
                onClick={() => handlePageStatus(menu.shortDesc, index + 1)}
              >
                <span className="hover:border-b">{t(menu.fullDesc)}</span>
              </li>
            ))}
            {/* <li>
              <Link to={"/micro-expressions-test"}>Free Test</Link>
            </li> */}
          </ol>
        </div>
      </div>
      {isLoading && <LoadingScreen />}{" "}
      {isNextStep && (
        <div className="fixed top-0 bottom-0 left-0 right-0 bg-gray-800 bg-opacity-80 pt-8 px-8 z-[3000] text-white ">
          <div className="bg-[#152034] p-4 relative text-base text-left md:w-[60%] mx-auto">
            <p className="text-center text-2xl mb-2 font-bold">Next Steps</p>
            <p className="mb-2">
              1. Exercise regularly with this program and connect with our
              network on{" "}
              <a
                href="http://www.facebook.com/pages/Center-for-Body-Language/186060558133706"
                target="_blank"
                className="text-blue-400 underline"
              >
                Facebook
              </a>
              ,{" "}
              <a
                href="https://www.linkedin.com/in/wezowski/"
                target="_blank"
                className="text-blue-400 underline"
              >
                LinkedIN
              </a>{" "}
              and{" "}
              <a
                href="https://twitter.com/pwezowski"
                target="_blank"
                className="text-blue-400 underline"
              >
                Twitter
              </a>
              .
            </p>
            <p className="mb-2">
              2. Become a{" "}
              <a
                href="https://microexpressionstrainingvideos.com/overview/"
                target="_blank"
                className="text-blue-400 underline"
              >
                Certified Practitioner, Coach or Trainer
              </a>{" "}
              with our online training programs
            </p>
            <div
              className="absolute top-2 right-2 cursor-pointer"
              onClick={() => setIsNextStep(false)}
            >
              <FaTimes />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainMenu;
